"use strict";

module.exports = function (same) {
  return same;
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/identity.js
// module id = 725
// module chunks = 37